const screenBreakpoints = {
  MIN_DESKTOP_SCREEN: 768,
  MIN_LARGE_SCREEN: 1024,
};

export default screenBreakpoints;
